export default __webpack_public_path__ + "static/x2y2-8b909458eb8f42297e730693e5e34bfb.png";